/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetAllocationOverrideItem } from './AssetAllocationOverrideItem';
import {
    AssetAllocationOverrideItemFromJSON,
    AssetAllocationOverrideItemFromJSONTyped,
    AssetAllocationOverrideItemToJSON,
} from './AssetAllocationOverrideItem';

/**
 * 
 * @export
 * @interface AssetAllocationOverrideRequest
 */
export interface AssetAllocationOverrideRequest {
    /**
     * 
     * @type {Array<AssetAllocationOverrideItem>}
     * @memberof AssetAllocationOverrideRequest
     */
    overrides: Array<AssetAllocationOverrideItem>;
}

/**
 * Check if a given object implements the AssetAllocationOverrideRequest interface.
 */
export function instanceOfAssetAllocationOverrideRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "overrides" in value;

    return isInstance;
}

export function AssetAllocationOverrideRequestFromJSON(json: any): AssetAllocationOverrideRequest {
    return AssetAllocationOverrideRequestFromJSONTyped(json, false);
}

export function AssetAllocationOverrideRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocationOverrideRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'overrides': ((json['overrides'] as Array<any>).map(AssetAllocationOverrideItemFromJSON)),
    };
}

export function AssetAllocationOverrideRequestToJSON(value?: AssetAllocationOverrideRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'overrides': ((value.overrides as Array<any>).map(AssetAllocationOverrideItemToJSON)),
    };
}

